// 检查点审核的纯逻辑：字段排序（红黄在前）、谁能审、reviewer=both 时已批准的一方
import type { FieldDiffItem, ReviewDTO, Reviewer, Role } from "@csp/shared";

const ORDER: Record<FieldDiffItem["result"], number> = { mismatch: 0, uncertain: 1, match: 2 };

export function sortDiff(diff: FieldDiffItem[]): FieldDiffItem[] {
  return diff
    .map((d, i) => ({ d, i }))
    .sort((a, b) => ORDER[a.d.result] - ORDER[b.d.result] || a.i - b.i)
    .map((x) => x.d);
}

export function diffCounts(diff: FieldDiffItem[]): { red: number; yellow: number; green: number } {
  return {
    red: diff.filter((d) => d.result === "mismatch").length,
    yellow: diff.filter((d) => d.result === "uncertain").length,
    green: diff.filter((d) => d.result === "match").length,
  };
}

/** 与后端 canReview 一致 */
export function canReview(reviewer: Reviewer, role: Role): boolean {
  if (role === "admin") return true;
  if (reviewer === "either" || reviewer === "both") return role === "clerk" || role === "boss";
  return reviewer === role;
}

/** reviewer=both：已批准的人与角色 */
export function approvalsOf(review: Pick<ReviewDTO, "approvals">): { whos: string[]; roles: Set<string> } {
  const list = review.approvals ?? [];
  return { whos: list.map((a) => a.who), roles: new Set(list.map((a) => a.role)) };
}
